<template>
	<div class="pagination">
	    <ul class="paginationUl">
	      <li v-for="page in pages"  :key="page" :class="{ active: page === activePage }" @click="pageClick(page)">{{ page }}</li>
	    </ul>
	 
		<button @click="nextPage" :disabled="activePage === totalPages" class="nexPage">{{$t('components.pagination.next')}}</button>
	  
	  </div>
</template>

<script>
	export default {
	name: 'HelloWorld',
	  props: {
	    TotalCount: Number,
	    pageSize: Number
	  },
	  data() {
	    return {
	      activePage: 1,		  
	    };
	  },
	  computed: {
	    totalPages() {
	      return Math.ceil(this.TotalCount / this.pageSize);
	    },
	    pages() {
		  const pageCount =  Math.ceil(this.TotalCount / this.pageSize);
		  const pages = [];
		  for(let i = 1; i <= pageCount; i++){
			  pages.push(i)
		  }			
		  return pages
	    }
	  },
	  methods: {
	    nextPage() {
		 if (this.activePage < this.totalPages) {
			 this.activePage++;
			 this.$emit('pageChenged',this.activePage);
		 }
		},
		pageClick(i){
			this.activePage = i;
			 this.$emit('pageChenged',this.activePage);
		}
	  }
	};
</script>

<style scoped>
	
	.pagination{
		display: flex;
		align-items: center;
	}
	
	.paginationUl{
		display: flex;
		align-items: center;
	}
	
	.paginationUl li{
		list-style: none;
		width: 40px;
		height: 29px;
		border: 1px solid #9b9b9b;
		color: #0380fe;
		font-size: 13px;
		text-align: center;
		line-height: 29px;
		margin-right: 5px;
		cursor: pointer;
		background-color: #fff;
	}
	
	.paginationUl li.active{
		background-color: #0380fe;
		color: #fff;
	}
	
	.nexPage{
		width: 85px;
		height: 29px;
		border: 1px solid #9b9b9b;
		background-color: #fff;
		color: #0380fe;
		font-size: 13px;
		text-align: center;
		line-height: 29px;
		cursor: pointer;
	}
	
	button:disabled{
		cursor: default;
	}
</style>